import { storeLedgerResult } from "../data/actions";

export const setLedgersInEdit = (values, dispatch, componentType) => {
  let ledgerTypes = [];
  if (componentType === "segmapForm") {
    ledgerTypes = [
      { key: "seg_ledger", code: "seg_ledger_cd" },
      { key: "stpi_segLedger", code: "stpi_seg_ledger_cd" },
      { key: "wi_sl_pur_ledger", code: "wi_sl_pur_ledger_cd" },
      { key: "ci_sl_pur_ledger", code: "ci_sl_pur_ledger_cd" },
      { key: "pp_sl_pur_ledger", code: "pp_sl_pur_ledger_cd" },
      { key: "ew_sl_pur_ledger", code: "ew_sl_pur_ledger_cd" },
      { key: "ewc_sl_pur_ledger", code: "ewc_sl_pur_ledger_cd" },
      { key: "ccp_sl_pur_ledger", code: "ccp_sl_pur_ledger_cd" },
      { key: "ccpc_sl_pur_ledger", code: "ccpc_sl_pur_ledger_cd" },
    ];

    ledgerTypes.forEach(({ key, code }) => {
      const value = values[key];
      if (value !== null && value !== undefined && value !== "") {
        dispatch(
          storeLedgerResult(
            [
              {
                key: value,
                value: value,
                text: value,
                title: value,
                ledgerName: values[key] || "",
                ledgerCode: values[code] || "",
              },
            ],
            key
          )
        );
      }
    });
  }

  if (componentType === "ledgermapForm") {
    ledgerTypes = [
      { key: "rlb_name", code: "rlb_id", gstinNo: "rlb_gstin" },
      { key: "dr_msil", code: "dr_msil_code" },
      { key: "dler_disc", code: "" },
      { key: "cr_msil", code: "cr_msil_code" },
      { key: "control_ldgr", code: "" },
      { key: "dr_msil", code: "" },
      { key: "dler_disc", code: "dler_disc_code" },
      { key: "cr_msil", code: "" },
      { key: "control_ldgr", code: "control_ldgr_code" },
    ];

    ledgerTypes.forEach(({ key, code, gstinNo }) => {
      const value = values[key];
      if (value !== null && value !== undefined && value !== "") {
        dispatch(
          storeLedgerResult(
            [
              {
                key: value,
                value: value,
                text: value,
                title: value,
                ledgerName: values[key] || "",
                ledgerCode: values[code] || "",
                gstinNo: values[gstinNo] || "",
              },
            ],
            key
          )
        );
      }
    });
  }

  if (componentType === "vtparammapForm") {
    const paramValue = values["PARAM_VALUE"];
    if (paramValue !== null && paramValue !== undefined && paramValue !== "") {
      dispatch(
        storeLedgerResult(
          [
            {
              key: paramValue,
              value: paramValue,
              text: paramValue,
              title: paramValue,
              ledgerName: paramValue,
              ledgerCode: paramValue,
            },
          ],
          "lcs_ledger_name"
        )
      );
    }
  }

  if (componentType === "vtparammapFormLNS") {
    const paramValue = values["PARAM_VALUE"];
    if (paramValue !== null && paramValue !== undefined && paramValue !== "") {
      dispatch(
        storeLedgerResult(
          [
            {
              key: paramValue,
              value: paramValue,
              text: paramValue,
              title: paramValue,
              ledgerName: paramValue,
              ledgerCode: "",
            },
          ],
          "lns_ledger_search"
        )
      );
    }
  }

  if (componentType === "vtparammapFormLCD") {
    const paramValue = values["PARAM_VALUE"];
    if (paramValue !== null && paramValue !== undefined && paramValue !== "") {
      let ledgerName = "";
      let ledgerCode = "";
      try {
        const obj = JSON.parse(paramValue);
        const keys = Object.keys(obj || {});
        if (keys.length > 0) {
          ledgerName = keys[0];
          ledgerCode = obj[ledgerName] || "";
        }
      } catch (e) {
        ledgerName = paramValue;
      }
      if (ledgerName) {
        dispatch(
          storeLedgerResult(
            [
              {
                key: ledgerName,
                value: ledgerName,
                text: ledgerName,
                title: ledgerName,
                ledgerName: ledgerName,
                ledgerCode: ledgerCode,
              },
            ],
            "lcd_ledger_search"
          )
        );
      }
    }
  }

  if (componentType === "itemmapForm") {
    ledgerTypes = [
      { key: "item_wise_sale_ledger", code: "item_wise_sale_ledger_cd" },
      { key: "item_wise_purchase_ledger", code: "item_wise_purchase_ledger_cd" },
      { key: "item_wise_sto_ledger", code: "item_wise_sto_ledger_cd" },
      { key: "item_wise_sti_ledger", code: "item_wise_sti_ledger_cd" },
    ];

    ledgerTypes.forEach(({ key, code }) => {
      const value = values[key];
      if (value !== null && value !== undefined && value !== "") {
        dispatch(
          storeLedgerResult(
            [
              {
                key: value,
                value: value,
                text: value,
                title: value,
                ledgerName: values[key] || "",
                ledgerCode: values[code] || "",
              },
            ],
            key
          )
        );
      }
    });
  }
};
